<template>
    <div class="addAndModify">
        <el-container>
            <el-main ref="main" class="tabWrap">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
                        <el-form class="dataFormBox" :inline="true" :model="dataForm">
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="标题：">
                                        <el-input v-model="dataForm.title" placeholder="请输入标题" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="发文字号：">
                                        <el-input v-model="dataForm.documentNum" placeholder="请输入发文字号" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="发文分类：">
                                        <el-select v-model="dataForm.documentTypeId" style="width: 100%;" disabled placeholder="请选择发文分类">
                                            <el-option :label="deptItem.name" :value="deptItem.id" v-for="(deptItem,deptIndex) in typeList" :key="'deptItem'+deptIndex"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="发文日期：">
                                        <el-date-picker
                                                v-model="dataForm.documentDate"
                                                value-format="yyyy-MM-dd"
                                                :readonly="true"
                                                type="date"
                                                placeholder="请选择发文日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <!--                <el-col :span="8">-->
                                <!--                  <el-form-item label-width="120px" label="拟稿部门：">-->
                                <!--                    <el-input v-model="dataForm.documentDraftDeptId" placeholder="请输入拟稿部门" clearable></el-input>-->
                                <!--                  </el-form-item>-->
                                <!--                </el-col>-->
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="拟稿日期：">
                                        <el-date-picker
                                                v-model="dataForm.documentDraftDate"
                                                value-format="yyyy-MM-dd"
                                                :readonly="true"
                                                type="date"
                                                placeholder="请选择拟稿日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="核稿日期：">
                                        <el-date-picker
                                                v-model="dataForm.documentApproveDate"
                                                value-format="yyyy-MM-dd"
                                                :readonly="true"
                                                type="date"
                                                placeholder="请选择核稿日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <div class="sendList">
                                        <el-form-item
                                                label="拟稿部门："
                                                label-width="120px"
                                                ref="sendListRef"
                                        >
                                            <div class="el-input tag-wrapper">
                                                <el-tag
                                                        v-for="(tag, index) in dataForm.documentDraftDeptJson"
                                                        :key="index"
                                                        style="margin-right: 5px;"
                                                >{{ tag.name }}</el-tag
                                                >
                                            </div>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="24">
                                  <div class="sendList">
                                    <el-form-item
                                        label="主送："
                                        label-width="120px"
                                        ref="sendListRef"
                                    >
                                      <div class="el-input tag-wrapper">
                                        <el-tag
                                            v-for="(tag, index) in dataForm.sendListJson"
                                            :key="index"
                                            style="margin-right: 5px;"
                                        >{{ tag.displayName || tag.name }}</el-tag
                                        >
                                      </div>
                                    </el-form-item>
                                  </div>
                                </el-col>
                                <el-col :span="24">
                                  <div class="sendList">
                                    <el-form-item
                                        label="抄送："
                                        label-width="120px"
                                        ref="ccListRef"
                                    >
                                      <div class="el-input tag-wrapper">
                                        <el-tag
                                            v-for="(tag, index) in dataForm.ccListJson"
                                            :key="index"
                                            style="margin-right: 5px;"
                                        >{{ tag.displayName || tag.name }}</el-tag
                                        >
                                      </div>
                                    </el-form-item>
                                  </div>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item class="maxWidth" label-width="120px" label="备注：">
                                        <el-input v-model="dataForm.remark" placeholder="请输入备注信息" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="附件" name="Tab2">
                        <div>
                            <el-table :data="fileList"
                                      style="width: 100%; margin: 20px"
                                      size="mini"
                                      border>
                                <el-table-column type="index" width="50" label="序号"></el-table-column>
                                <el-table-column
                                        v-for="(prop, index) in tableProps"
                                        :key="index"
                                        :prop="prop.prop"
                                        :label="prop.label"
                                        :min-width="prop.width"
                                ></el-table-column>
                                <el-table-column label="操作" width="150">
                                    <template slot-scope="scope">
                                        <el-button
                                                size="mini"
                                                @click="downloadFile(scope.$index, scope.row)"
                                                type="text"
                                        >下载附件</el-button>
                                        <el-button
                                                size="mini"
                                                @click="previewFile(scope.$index, scope.row,'document')"
                                                type="text"
                                        >预览</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="审批流程" name="Tab3" style="height: 700px;overflow-y: auto">
                        <div v-if="approveFlag === 'currentApprove'">
                            <approveItem
                                    :itemId="contractId"
                                    :approveType="approveType"
                                    :subapproveType="subapproveType"
                                    @finishApprove="close()"
                            >
                            </approveItem>
                        </div>
                        <div v-else>
                            <approveLine
                                    :itemId="contractId"
                                    :approveType="approveType"
                            ></approveLine>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="查阅与办理情况" v-if="dataForm.applyUserName == loginName" name="Tab4">
                        <el-table :data="checkList"
                                      style="width: 100%; margin: 20px"
                                      size="mini"
                                  max-height="300"
                                  border>
                                <el-table-column label="查阅人姓名" prop="userName"></el-table-column>
                                <el-table-column label="查阅时间" prop=""></el-table-column>
                                <el-table-column label="处理状态" prop="commitStatusDisplayName"></el-table-column>
                                <el-table-column label="处理完成时间" prop="finishTime"></el-table-column>
                                <el-table-column label="处理意见" prop="commitComment"></el-table-column>
                                <el-table-column label="回复消息" prop="lastCommit"></el-table-column>
                                <el-table-column label="回复时间" prop="lastCommitTime"></el-table-column>
                                <el-table-column label="操作" width="150">
                                    <template slot-scope="scope">
                                        <el-button
                                                size="mini"
                                                @click="setDialogVisible(scope.row)"
                                                type="text"
                                        >回复</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        <el-footer>
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="checkPageIndex"
                                    :page-sizes="[10, 20, 30, 50, 100]"
                                    :page-size="checkPageSize"
                                    layout="total, prev, pager, next, sizes, jumper"
                                    :total="checkTotal"
                            ></el-pagination>
                        </el-footer>
                        <replyComp v-if="replyCompVisible" :userName="userName" :checkId="checkId" ref="replyComp" @refreshDataList="getCheckList" />
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="containerBox">
                <div class="btnMid">
                    <el-button type="info" @click="close()">关 闭</el-button>
                </div>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import {
        getSendDetailService,
        getTypeListService,
        getCheckListService
    } from "@/services/documentServices";

    import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
    import approveItem from "@/page/approveComponents/ApproveItem";
    import replyComp from '../replyComp'
    import {previewFile} from "@/utils/index.js"
    import {goBackApprove} from '@/page/approveComponents/approve';
    import {
        exportExcelService2, //导出
        getTempUrlService //下载附件
    } from "@/services/allContractServices";
    export default {
        name: "detailAndApprove",
        data() {
            return {
                activeName: 'Tab1',
                dataForm:{
                    id:'', //id
                    title: '',  //标题
                    documentNum: '',  //发文字号
                    documentTypeId: '',  //发文分类id
                    documentDate: '',  //发文日期
                    documentDraftDate: '',  //拟稿日期
                    documentApproveDate: '',  //核稿日期
                    sendListJson: [],  //主送
                    ccListJson: [],  //抄送
                    documentDraftDeptJson: [],  //部门
                    remark: '',  //备注
                },
                approveFlag: '', //审批状态
                approveType: "OFFICIAL_DOCUMENT_INTERNAL ", //审批类型
                subapproveType: '',
                contractId: 0,
                fileList:[],
                tableProps: [
                    { prop: "name", label: "文件名称", width: "200px" },
                    { prop: "uploadUserName", label: "上传者", width: "140px" },
                    { prop: "uploadTime", label: "上传时间", width: "140px" },
                ],
                typeList: [], //发文分类列表
                checkList: [], //回复列表
                checkPageIndex: 1,
                checkPageSize: 10,
                checkTotal: 0,
                replyCompVisible: false,
                userName: '',
                checkId: '',
                loginName: sessionStorage.getItem('name'),
            }
        },
        components: {
            approveLine, //审批历史流程
            approveItem, //审批
            replyComp,
        },
        methods: {
            onActive(menuCode) {
                if(this.tabRouteParam.id){
                    this.dataForm.id = this.tabRouteParam.id;
                    this.approveFlag = this.tabRouteParam
                        ? this.tabRouteParam.approveFlag
                        : "";
                    this.contractId = Number(this.tabRouteParam.id);
                    this.getSendDetail();
                }
                this.getTypeList();
            },
            //获取发文详情
            getSendDetail(){
                let paramsData = {
                    systemFileInternalId: this.dataForm.id
                }
                getSendDetailService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.dataForm = {
                            id: res.data.id,
                            title: res.data.title,  //标题
                            documentNum: res.data.documentNum,  //发文字号
                            documentTypeId: res.data.documentTypeId,  //发文分类id
                            documentDate: res.data.documentDate,  //发文日期
                            documentDraftDate: res.data.documentDraftDate,  //拟稿日期
                            documentApproveDate: res.data.documentApproveDate,  //核稿日期
                            sendListJson: res.data.sendListJson ? JSON.parse(res.data.sendListJson) : "",  //主送
                            ccListJson: res.data.ccListJson ? JSON.parse(res.data.ccListJson) : "",  //抄送
                            documentDraftDeptJson: JSON.parse(res.data.documentDraftDeptJson),  //部门
                            remark: res.data.remark,  //备注
                            applyUserName: res.data.applyUserName,  //申请人
                        }
                        this.fileList = res.data.attachmentList;
                        if(res.data.sendStatus == 4){
                            this.getCheckList()
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //获取回复列表
            getCheckList(){
                let paramsData = {
                    systemFileInternalId: this.dataForm.id,
                    pageIndex: this.checkPageIndex,
                    pageSize: this.checkPageSize,
                }
                getCheckListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.checkList = res.data;
                        this.checkTotal = res.total;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.checkPageIndex = page;
                this.getCheckList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.checkPageIndex = 1;
                this.checkPageSize = rows;
                this.getCheckList();
            },
            //查询发文分类列表
            getTypeList(){
                let paramsData = {
                    pageIndex: 1,
                    pageSize: 10000,
                }
                getTypeListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.typeList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //文件下载
            downloadFile(index, row) {
                let reqParam = {
                    filePath: row.attachmentItem
                };
                getTempUrlService(reqParam).then(
                    res => {
                        if (res.code == 10000000) {
                            //下载附件
                            const link = document.createElement('a');
                            // 这里是将链接地址url转成blob地址，
                            fetch(res.data).then(res => res.blob()).then(blob => {
                                link.href = URL.createObjectURL(blob)
                                // 下载文件的名称及文件类型后缀
                                link.download = row.name;
                                document.body.appendChild(link)
                                link.click()
                                //在资源下载完成后 清除 占用的缓存资源
                                window.URL.revokeObjectURL(link.href);
                                document.body.removeChild(link);
                            });
                            // exportExcelService2(res.data).then(res1 => {
                            //   this.$alert("下载成功", "提示", {
                            //     confirmButtonText: "确定"
                            //   });
                            // });
                        } else {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    },
                    err => {
                        this.$alert("系统异常", "提示", {
                            confirmButtonText: "确定"
                        });
                    }
                );
            },
            //文件预览
            previewFile,

            setDialogVisible(row){
                this.userName = row.userName;
                this.checkId = row.id;
                this.replyCompVisible = true;
                this.$nextTick(()=> {
                    this.$refs.replyComp.userId = row.userId;
                    this.$refs.replyComp.systemFileInternalId = this.dataForm.id;
                    this.$refs.replyComp.init();
                })
            },

            // 关闭
            close(){
                if(this.approveFlag){
                  console.log(this.approveFlag)
                    goBackApprove(this.approveFlag,'generalOfficeDetails')
                }else{
                    this.bus.$emit("tabClose", "generalOfficeDetails");
                    this.bus.$emit("navMenuChange", {
                        routeId: "documentManage"
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .addAndModify {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .tabWrap {
            height: calc(100% - 60px);

            /deep/ .el-tabs--top {
                height: 100%;
                overflow: hidden;

                .el-tabs__content {
                    height: calc(100% - 140px);
                    padding: 0 20px 20px;
                    overflow: auto;

                    .el-form-item {
                        width: 100%;
                    }

                    .el-checkbox {
                        line-height: 40px;
                    }

                    .el-textarea {
                        min-width: 0px !important;
                    }
                    .el-cascader {
                        width: 100%;
                    }

                    .el-form-item__content {
                        width: calc(100% - 150px);

                        .el-input {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
    .sendList {
        /deep/.el-form-item{
            width: 100%;
            display: flex;
            .el-form-item__content {
                width: 80%;
                display: flex;
                .el-input {
                    flex: 1;
                }
                .el-button {
                    margin-left: 10px;
                    height: fit-content;
                }
            }
        }

        .tag-wrapper {
            border: 1px solid #dcdfe6;
            padding: 0 5px;
        }
    }
    .containerBox {
        width: 100%;
        height: 36px !important;
        position: fixed;
        bottom: 44px;
        left: 0;
        text-align: start;
    }
    .btnMid {
        position: relative;
        left: 27%;
        bottom: 0px;
        display: flex;
    }
    /deep/.ApproveItem .bottomBtn{
        bottom: 44px;
        z-index: 10;
    }
</style>
